import { Global, css } from '@emotion/react';

const resetStyle = css({
  /*
  1. Use a more-intuitive box-sizing model.
*/
  '*, *::before, *::after': {
    boxSizing: 'border-box',
  },

  /*
  2. Remove default margin
*/
  '*': {
    margin: 0,
  },

  /*
  3. Allow percentage-based heights in the application
*/
  'html, body': {
    height: '100%',
  },
  /*
  6. Improve media defaults
*/
  'img, picture, video, canvas, svg': {
    display: 'block',
    maxWidth: '100%',
  },

  /*
  7. Remove built-in form typography styles
*/
  'input, button, textarea, select': {
    font: 'inherit',
  },
});

export const ResetStyle = () => {
  return <Global styles={resetStyle} />;
};
